<template>
    <v-form ref="paymentForm" v-model="form.valid">
        <v-row>
            <v-col cols="12" class="text-center pt-6">
                <p class="subtitle-1">Please enter your card details below. We only accept <b>Mastercard</b> or <b>VISA</b> at this time.</p>
                <p class="subtitle-1">Your card details will not be saved for future payments. There is no fee for payments made by card.</p>
            </v-col>
        </v-row>
        <v-row align="center">
            <v-col cols="12" md="6">
                <VuePaycard
                        :value-fields="valueFields"
                        :has-random-backgrounds="false"
                        :input-fields="inputFields"
                        :is-card-number-masked="false"
                />
            </v-col>
            <v-col cols="12" md="6" class="align-content-center">
                <div class="pt-8" style="max-width: 600px; margin: 0 auto;">
                    <v-text-field
                            :id="inputFields.cardName"
                            name="cardName"
                            label="Cardholder Name"
                            v-model="valueFields.cardName"
                            :rules="form.name.rules"
                            @input="changeName"
                            required
                            data-card-field
                            outlined
                    />
                    <v-text-field
                            id="cardNumber"
                            name="cardNumber"
                            label="Card Number"
                            :error-messages="form.cardNumber.errors"
                            v-model="form.cardNumber.value"
                            :rules="form.cardNumber.rules"
                            @input="changeNumber"
                            required
                            data-card-field
                            v-number-only
                            :maxlength="form.cardNumber.max"
                            outlined
                    />
                    <v-row dense>
                        <v-col cols="4">
                            <v-select
                                    :id="inputFields.cardMonth"
                                    name="cardMonth"
                                    label="Expiry Month"
                                    :items="months"
                                    :error-messages="form.expiry.errors"
                                    :rules="form.expiry.rules"
                                    @input="changeExpiry"
                                    item-value="value"
                                    item-text="text"
                                    v-model="valueFields.cardMonth"
                                    data-card-field
                                    outlined
                            />
                        </v-col>
                        <v-col cols="4">
                            <v-select
                                    :id="inputFields.cardYear"
                                    name="cardYear"
                                    label="Expiry Year"
                                    :rules="form.expiry.rules"
                                    :error-messages="form.expiry.errors"
                                    :items="years"
                                    @input="changeExpiry"
                                    v-model="valueFields.cardYear"
                                    data-card-field
                                    outlined
                            />
                        </v-col>
                        <v-col cols="4">
                            <v-text-field
                                    :id="inputFields.cardCvv"
                                    name="cardCvv"
                                    label="CVV"
                                    v-model="valueFields.cardCvv"
                                    :rules="form.cvv.rules"
                                    @input="changeCVV"
                                    required
                                    :error-messages="form.cvv.errors"
                                    :maxlength="form.cvv.max"
                                    v-number-only
                                    data-card-field
                                    outlined
                            />
                        </v-col>
                    </v-row>
                </div>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
    import { VuePaycard } from 'vue-paycard'

    export default {
        name: "PaymentDetails",
        components: {VuePaycard},
        data: () => ({
            minCardYear: new Date().getFullYear(),
            form: {
                valid: false,
                name: {
                    rules: [
                        v => !!v || 'Cardholder Name is required'
                    ]
                },
                cardNumber: {
                    value: '',
                    valid: false,
                    errors: [],
                    rules: [
                        v => !!v || 'Card Number is required',
                    ],
                    max: 16,
                    type: ''
                },
                expiry: {
                    rules: [
                        v => !!v || 'Expiry is required'
                    ],
                    errors: []
                },
                cvv: {
                    max: 3,
                    rules: [
                        v => !!v || 'CVV is required'
                    ],
                    errors: []
                }
            },
            valueFields: {
                cardName: '',
                cardNumber: '',
                cardMonth: '',
                cardYear: '',
                cardCvv: ''
            },
            inputFields: {
                cardName: 'cardName',
                cardNumber: 'cardNumber',
                cardMonth: 'cardMonth',
                cardYear: 'cardYear',
                cardCvv: 'cardCvv'
            },
            months: [
                {value: "01", text: '01 January'},
                {value: "02", text: '02 February'},
                {value: "03", text: '03 March'},
                {value: "04", text: '04 April'},
                {value: "05", text: '05 May'},
                {value: "06", text: '06 June'},
                {value: "07", text: '07 July'},
                {value: "08", text: '08 August'},
                {value: "09", text: '09 September'},
                {value: "10", text: '10 October'},
                {value: "11", text: '11 November'},
                {value: "12", text: '12 December'}
            ]

        }),
        computed: {
            minCardMonth () {
                if (this.valueFields.cardYear === this.minCardYear) return new Date().getMonth() + 1
                return 1
            },
            years () {
                var currentYear = new Date().getFullYear();
                var data = [];
                var i;
                for (i=0; i < 20; i++) {
                    data.push(currentYear + i);
                }
                return data;
            }
        },
        watch: {
            'form.valid': function(val) {
                if (val) {
                    this.$emit('valid', {
                        name: this.valueFields.cardName,
                        cc: this.form.cardNumber.value,
                        month: this.valueFields.cardMonth,
                        year: this.valueFields.cardYear,
                        cvv: this.valueFields.cardCvv,
                    });
                } else {
                    this.$emit('invalid');
                }
            }
        },
        directives: {
            'number-only': {
                bind (el) {
                    function checkValue (event) {
                        event.target.value = event.target.value.replace(/[^0-9]/g, '')
                        if (event.charCode >= 48 && event.charCode <= 57) {
                            return true
                        }
                        event.preventDefault()
                    }
                    el.addEventListener('keypress', checkValue)
                }
            },
            'letter-only': {
                bind (el) {
                    function checkValue (event) {
                        if (event.charCode >= 48 && event.charCode <= 57) {
                            event.preventDefault()
                        }
                        return true
                    }
                    el.addEventListener('keypress', checkValue)
                }
            }
        },
        methods: {
            changeName() {
                if (this.form.valid) {
                    this.$emit('valid', {
                        name: this.valueFields.cardName,
                        cc: this.form.cardNumber.value,
                        month: this.valueFields.cardMonth,
                        year: this.valueFields.cardYear,
                        cvv: this.valueFields.cardCvv,
                    });
                }
            },
            changeExpiry() {
                if (this.valueFields.cardMonth !== '' && this.valueFields.cardYear === new Date().getFullYear()) {
                    if (parseInt(this.valueFields.cardMonth.replace(/0(\d)/g, "$1")) <= new Date().getMonth()) {
                        this.form.expiry.errors = ['Expiry in the past'];
                        return;
                    }
                }
                this.form.expiry.errors = [];
                if (this.form.valid) {
                    this.$emit('valid', {
                        name: this.valueFields.cardName,
                        cc: this.form.cardNumber.value,
                        month: this.valueFields.cardMonth,
                        year: this.valueFields.cardYear,
                        cvv: this.valueFields.cardCvv,
                    });
                }

            },
            changeCVV() {
                if (this.valueFields.cardCvv.length > 0 && this.valueFields.cardCvv.length < this.form.cvv.max) {
                    this.form.cvv.errors = ["CVV is incomplete"];
                } else if (this.valueFields.cardCvv.length > this.form.cvv.max) {
                    this.form.cvv.errors = ["CVV is invalid"];
                } else {
                    this.form.cvv.errors = [];
                }
                if (this.form.valid) {
                    this.$emit('valid', {
                        name: this.valueFields.cardName,
                        cc: this.form.cardNumber.value,
                        month: this.valueFields.cardMonth,
                        year: this.valueFields.cardYear,
                        cvv: this.valueFields.cardCvv,
                    });
                }
            },
            changeNumber() {
                // remove all but numbers
                this.form.cardNumber.value = this.form.cardNumber.value.replace(/\D/g, "");
                if (this.form.cardNumber.value.length===0) {
                    this.form.cardNumber.valid = false;
                    this.form.cardNumber.type = '';
                    this.valueFields.cardNumber = '';
                    return;
                }
                var cardValidator = require('card-validator');
                var result = cardValidator.number(this.form.cardNumber.value);
                if (!result.isPotentiallyValid && !result.isValid) {
                    this.form.cardNumber.valid = false;
                    this.form.cardNumber.type = '';
                    this.form.cardNumber.errors = ["Card Number is invalid"];
                    this.valueFields.cardNumber = '';
                }
                if ((/^3[47]\d{0,13}$/).test(this.form.cardNumber.value)) {  // american express, 15 digits
                    this.valueFields.cardNumber = this.form.cardNumber.value.replace(/(\d{4})/, '$1 ').replace(/(\d{4}) (\d{6})/, '$1 $2 ')
                    this.form.cardNumber.max = 15;
                    this.form.cvv.max = 4;
                } else if ((/^3(?:0[0-5]|[68]\d)\d{0,11}$/).test(this.form.cardNumber.value)) { // diner's club, 14 digits
                    this.valueFields.cardNumber = this.form.cardNumber.value.replace(/(\d{4})/, '$1 ').replace(/(\d{4}) (\d{6})/, '$1 $2 ')
                    this.form.cardNumber.max = 14;
                    this.form.cvv.max = 3;
                } else if ((/^\d{0,16}$/).test(this.form.cardNumber.value)) { // regular cc number, 16 digits
                    this.valueFields.cardNumber = this.form.cardNumber.value.replace(/(\d{4})/, '$1 ').replace(/(\d{4}) (\d{4})/, '$1 $2 ').replace(/(\d{4}) (\d{4}) (\d{4})/, '$1 $2 $3 ')
                    this.form.cardNumber.max = 16;
                    this.form.cvv.max = 3;
                }
                this.changeCVV();
                if (result.card !== null) {
                    this.form.cardNumber.type = result.card.type;
                    if (result.card.type !== 'visa' && result.card.type !== 'mastercard') {
                        this.form.cardNumber.valid = true;
                        this.form.cardNumber.errors = ["We only accept VISA or Mastercard"];
                        return;
                    }
                } else {
                    this.form.cardNumber.type = '';
                }
                if (result.isValid) {
                    this.form.cardNumber.valid = true;
                    this.form.cardNumber.errors = [];
                    if (this.form.valid) {
                        this.$emit('valid', {
                            name: this.valueFields.cardName,
                            cc: this.form.cardNumber.value,
                            month: this.valueFields.cardMonth,
                            year: this.valueFields.cardYear,
                            cvv: this.valueFields.cardCvv,
                        });
                    }
                } else {
                    this.form.cardNumber.valid = false;
                    if (result.isPotentiallyValid && (this.form.cardNumber.value.length !== this.form.cardNumber.max)) {
                        this.form.cardNumber.errors = ["Card Number is incomplete"];
                    } else {
                        this.form.cardNumber.errors = ["Card Number is invalid"];
                    }
                }
            }
        }
    }
</script>